export var version = '2.4.10';


// WEBPACK FOOTER //
// ./src/cdn/libs/qiankun/es/version.js